var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_1337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5714 0.571045H3.4285C2.79732 0.571045 2.28564 1.08272 2.28564 1.7139V14.2853C2.28564 14.9165 2.79732 15.4282 3.4285 15.4282H12.5714C13.2025 15.4282 13.7142 14.9165 13.7142 14.2853V1.7139C13.7142 1.08272 13.2025 0.571045 12.5714 0.571045Z",
    stroke: "#888888",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14307 12.5712H8.85735",
    stroke: "#888888",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_1337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneicon);
export default __webpack_public_path__ + "static/media/phoneicon.649b260742726a99ee172a2d17af836e.svg";
export { ForwardRef as ReactComponent };